const style = {
  clientsControls: {},
  clientsControls__row: {
    'display': 'flex',
    'justifyContent': 'space-between',
    'alignItems': 'center',
    'padding': '3px 20px',

    '@media only screen and (max-width: 640px)': {
      padding: '10px 20px',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  clientsControls__userSearchInputForm: {
    paddingTop: '1px',
    width: '400px',
  },
};

export default style;
